import React from 'react';
import { Box, Text, Badge } from '@chakra-ui/react';
import { Tooltip } from '../../ui/tooltip';

const TruncatedText = ({
    text = '',
    maxLength = 50,
    showTooltip = true,
    fontSize = 'sm',
    showInChip = false,
    ...textProps
}) => {

    // Handle empty or null text
    if (!text || text === '-') {
        return <Text fontSize={fontSize} {...textProps}>{text || '-'}</Text>;
    }

    const textStr = String(text);
    const textLength = textStr.length;

    // Show as chip if 3 or fewer characters
    if (showInChip) {
        return (
            <Badge
                bg="blue.500"
                color="white"
                variant="solid"
                px={2}
                py={1}
                borderRadius="lg"
                fontSize={fontSize}
                fontWeight="medium"
                {...textProps}
            >
                {textStr}
            </Badge>
        );
    }

    const needsTruncation = textLength > maxLength;
    const displayText = needsTruncation ? `${textStr.slice(0, maxLength)}...` : textStr;

    // If no truncation needed, don't show tooltip
    if (!needsTruncation) {
        return <Text fontSize={fontSize} {...textProps}>{textStr}</Text>;
    }

    const TooltipContent = () => (
        <Box maxW="300px" p={2}>
            <Text fontSize="sm" mb={2} wordBreak="break-word">
                {textStr}
            </Text>
        </Box>
    );

    const TextElement = (
        <Text
            fontSize={fontSize}
            cursor="help"
            {...textProps}
        >
            {displayText}
        </Text>
    );

    // Only show tooltip for truncated text
    if (!showTooltip || !needsTruncation) {
        return TextElement;
    }

    return (
        <Tooltip
            content={<TooltipContent />}
            showArrow
            placement="top"
            openDelay={300}
            closeDelay={500}
            interactive
        >
            {TextElement}
        </Tooltip>
    );
};

export default TruncatedText;